import React, { memo } from 'react';

import { cssMap } from '@compiled/react';

import { Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

import { ActionCard } from './action-card';
import { validateCreateProjectProgressUpdateAction } from './validateCreateProjectProgressUpdateAction';

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.100'),
	},
});

const CreateProjectProgressUpdateActionRendererImpl = ({
	actions,
	...props
}: ActionRendererFor<typeof ActionKeys.CreateProjectProgressUpdate>): React.JSX.Element | null => {
	const validActions = actions.filter((a) => validateCreateProjectProgressUpdateAction(a).isValid);
	if (!validActions.length) {
		return null;
	}

	return (
		<Stack xcss={styles.container}>
			{validActions.map((action) => (
				<ActionCard key={action.actionId} action={action} {...props} />
			))}
		</Stack>
	);
};

export const CreateProjectProgressUpdateActionRenderer: React.MemoExoticComponent<
	({
		actions,
		...props
	}: ActionRendererFor<typeof ActionKeys.CreateProjectProgressUpdate>) => React.JSX.Element | null
> = memo(CreateProjectProgressUpdateActionRendererImpl);
